import {
  SCREEN_PATH,
  EMPTY_STRING,
  VERIFICATION_TOKEN,
} from "../constants/global.constants";
import {
  hasUserAccess,
  hasAgentAccess,
  hasAdminAccess,
} from "../shared/utility";
import { APPROVAL_STATUS, SUBSCRIPTION_STATUS } from "../system/global-enums";

export const handleNavigation = (
  isAuthenticated,
  user,
  userRole,
  navigate,
  pathname,
  verificationToken,
  isNavigateToDefault
) => {
  if (verificationToken) {
    let targetPath = "";
    // Handle navigation to reset password screen
    if (pathname.includes(SCREEN_PATH.RESET_PASSWORD)) {
      targetPath = `${SCREEN_PATH.RESET_PASSWORD}?${VERIFICATION_TOKEN}=${verificationToken}`;
    }
    // Handle navigation to email verification screen
    else if (pathname.includes(SCREEN_PATH.EMAIL_VERIFICATION)) {
      targetPath = `${SCREEN_PATH.EMAIL_VERIFICATION}?${VERIFICATION_TOKEN}=${verificationToken}`;
    } else {
      targetPath = SCREEN_PATH.LOGIN;
    }
    navigate(targetPath);
  }
  // Check if the user is authenticated
  else if (isAuthenticated) {
    if (pathname === SCREEN_PATH.LOGIN || isNavigateToDefault) {
      let path = EMPTY_STRING;
      // Determine navigation path based on user roles and statuses
      if (hasAdminAccess(userRole)) {
        // Admin users navigate to the admin dashboard
        path = SCREEN_PATH.ADMIN_DASHBOARD;
      } else if (hasUserAccess(userRole)) {
        // Regular users navigate based on subscription status
        path =
          user.subscriptionStatus === SUBSCRIPTION_STATUS.NOT_SUBSCRIBED
            ? SCREEN_PATH.SUBSCRIPTION_PLANS
            : SCREEN_PATH.HOME;
      } else if (hasAgentAccess(userRole)) {
        // Agents navigate based on approval and subscription statuses
        path =
          user.approvalStatus !== APPROVAL_STATUS.APPROVED
            ? SCREEN_PATH.AGENT_PROFILE
            : user.subscriptionStatus === SUBSCRIPTION_STATUS.NOT_SUBSCRIBED && !user.isPaymentDisabled
              ? SCREEN_PATH.AGENT_SUBSCRIPTION_PLANS
              : SCREEN_PATH.MY_LISTING;
      }
      navigate(path);
    }
  } else {
    if (!isAuthenticated && pathname.includes(SCREEN_PATH.PRIVACY_POLICY)) {
      navigate(SCREEN_PATH.PRIVACY_POLICY);
    } else {
      navigate(SCREEN_PATH.LOGIN, { replace: true });
    }
  }
};
